import { Checkbox } from '@gov-design-system-ce/react-form';
import type { DokumentyDokumentDto } from '@gov-nx/api';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';
import { toDateTimeReadable } from '@gov-nx/utils/common';

interface DocumentTableNoFileRowProps {
	document: DokumentyDokumentDto;
}

export const TableRowNoFile = ({ document }: DocumentTableNoFileRowProps) => {
	const {
		controls,
		code,
		myFilesModals: { setNoFileModal },
		formDefinition,
	} = useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	if (!document.dokumentId) {
		return null;
	}

	const createdAt =
		document.datumVytvoreni && toDateTimeReadable(document.datumVytvoreni);

	return (
		<li
			key={document.dokumentId}
			className="flex flex-col gap-(--spacing-s) relative p-(--templates-margin-l) border-b border-(--border-subtlest) [ last-of-type:border-b-0 ] [ md:mx-0 ]">
			<div className="flex flex-col gap-(--spacing-xs) [ md:flex-row md:gap-(--spacing-m) ]">
				<Button
					aria-label={tsn('akce.stahnout')}
					color="primary"
					type="link"
					onClick={() => setNoFileModal(document)}
					className="mr-auto!">
					<span className="w-60 mr-auto! truncate [ sm:w-80 ] [ md:w-130 ]">
						{document.nazev}
					</span>
				</Button>
				<div className="text-body-s text-(--text-secondary)">{createdAt}</div>
				<div className="absolute top-(--templates-margin-l) right-0 w-(--height-m-nudge) h-(--height-m-nudge) overflow-hidden [ md:relative md:top-auto md:right-auto ]">
					<div className="relative -mt-[10px]!">
						<Checkbox
							name={`selection.${document.dokumentId}`}
							size="m"
							isDisabled={controls.processLoading}
							hasNoLabel={true}
							aria-label={tsn('vyber.oznacit')}
							onChange={(e) => {
								formDefinition.formMethods.setValue(
									`selection.${document.dokumentId}`,
									e.target.checked
										? {
												checked: true,
												souborId: document.soubory?.[0]?.souborId,
											}
										: undefined
								);
							}}
							isChecked={
								formDefinition.formMethods.getValues(
									`selection.${document.dokumentId}`
								)?.checked
							}
						/>
					</div>
				</div>
			</div>
		</li>
	);
};
